import React from "react";
import {Icon, IconButton, PrimaryButton, Stack, Text} from "@fluentui/react";
import {useDispatch} from "react-redux";

import styles from "./IsaacErrorModal.module.scss";
import type IsaacErrorModalProps from "../isaacModalError/IsaacErrorModalProps";
import IsaacModal from "../isaacModal/IsaacModal";
import {flush} from "../../pages/layout/errorsSlice";

const IsaacErrorModal: React.FunctionComponent<IsaacErrorModalProps> = ({
  errors,
}) => {
  const dispatch = useDispatch();
  const isOpen = errors !== undefined && errors.length > 0;

  return (
    <IsaacModal
      isOpen={isOpen}
      containerClassName={styles.modalContainer}
      overlay={{className: styles.overlay}}
       handleDismiss={() => {
        dispatch(flush());
      }}>
      <Stack
        verticalAlign="center"
        horizontalAlign="center"
        verticalFill
        className={styles.container}>
        <div className={styles.closeBtnContainer}>
          <IconButton
            iconProps={{
              iconName: "ChromeClose",
            }}
            className={styles.closeBtn}
            onClick={() => dispatch(flush())}
          />
        </div>

        <Icon iconName="ErrorBadge" className={styles.icon} />
        <Text variant="xxLarge">Oops! Something went wrong.</Text>

        {errors === undefined && (
          <Text variant="large">API communication error occurred.</Text>
        )}
        {errors?.map((e, i) => (
          <Text key={i} variant="large" className={styles.errorsContainer}>
            {e.message ?? e.exception}
          </Text>
        ))}
        <PrimaryButton
          className={styles.retryBtn}
          text="Retry"
          onClick={() => {
            dispatch(flush());
            window.location.reload();
          }}
        />
      </Stack>
    </IsaacModal>
  );
};

export default IsaacErrorModal;
